import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { actionLoadingStates } from "../../utils/stateEnums";
import { getProfileAuthorisationStatus } from "../../utils/apiCallHandler/profileAuthorisationStatus";

const { idle, pending, succeeded, failed } = actionLoadingStates;

export const initialState = {
  loading: idle,
  canUseProfileApi: null,
};

export const loadProfileAuthorisationStatus = createAsyncThunk(
  `profileAuthStatus/load`,
  async ({ accessToken }) => {
    const response = await getProfileAuthorisationStatus(accessToken);
    return response?.data;
  },
);

export const resetProfileAuthorisationStatus = createAction(
  `profileAuthStatus/reset`,
);

export const reducers = {
  loadProfileAuthorisationStatus,
};

export const extraReducers = (builder) => {
  builder.addCase("profileAuthStatus/load/pending", (state) => {
    return { ...state, loading: pending };
  });
  builder.addCase("profileAuthStatus/load/fulfilled", (state, action) => {
    return {
      ...state,
      canUseProfileApi: action.payload.can_use_profile_api,
      loading: succeeded,
      justLoaded: true,
    };
  });
  builder.addCase("profileAuthStatus/load/rejected", (state, action) => {
    return { ...state, error: action.error, loading: failed };
  });
  builder.addCase(resetProfileAuthorisationStatus, () => {
    return { ...initialState };
  });
};
